import React from 'react'
import { EvidenceGroup } from '@trustero/trustero-api-web/lib/attachment/attachment_pb'
import { DocumentRequest } from '@trustero/trustero-api-web/lib/request/request_pb'
import { useMemo } from 'react'
import { TableListLoader } from 'src/components/Reusable/ContentLoaders/TableListLoader'
import { Grid } from 'src/components/Reusable/Grid'
import { RequestsItem } from 'src/pages/Requests/components/RequestsItem'
import { RequestsIndexGridHeader } from 'src/pages/Requests/RequestsIndexPage/RequestsIndexGridHeader'
import { REQUEST_GRID_LOCATIONS } from 'src/pages/Requests/RequestsIndexPage/RequestsIndexPage.constants'
import { DocumentRequestsTabNoResults } from 'src/pages/Evidence/evidence.components'
import { LinkEvidenceToRequestsModal } from 'src/pages/Evidence/modals/LinkEvidenceToRequestsModal'
import { EvidenceRequestsItemMenu } from './EvidenceDocumentRequestsBody.components'

export const EvidenceDocumentRequestsBody = ({
  evidence,
  requests,
  isLoading,
}: {
  evidence: EvidenceGroup
  requests: DocumentRequest[]
  isLoading: boolean
}): JSX.Element => {
  const currentRequestIds = useMemo(
    () => requests.map((r) => r.getId()),
    [requests],
  )

  return isLoading ? (
    <TableListLoader />
  ) : (
    <>
      {requests.length ? (
        <Grid
          gridTemplateColumns={`min-content 1fr repeat(6, auto)`}
          gridRowGap="8px"
        >
          <RequestsIndexGridHeader
            requests={requests}
            location={REQUEST_GRID_LOCATIONS.EVIDENCE_SHOW}
          />
          <>
            {requests.map((request) => (
              <RequestsItem
                key={request.getId()}
                request={request}
                fromEvidenceShowPage
                customMenu={
                  <EvidenceRequestsItemMenu
                    requestId={request.getId()}
                    evidenceGroup={evidence}
                  />
                }
              />
            ))}
          </>
        </Grid>
      ) : (
        <DocumentRequestsTabNoResults />
      )}
      <LinkEvidenceToRequestsModal
        existingRequestIds={currentRequestIds}
        evidenceId={evidence.getEvidenceId()}
      />
    </>
  )
}
